"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.HandlerTypes = void 0;
var HandlerTypes;
exports.HandlerTypes = HandlerTypes;

(function (HandlerTypes) {
  HandlerTypes[HandlerTypes["Js"] = 0] = "Js";
  HandlerTypes[HandlerTypes["ResponseMessage"] = 1] = "ResponseMessage";
  HandlerTypes[HandlerTypes["NotFound"] = 2] = "NotFound";
  HandlerTypes[HandlerTypes["Unauthorized"] = 3] = "Unauthorized";
  HandlerTypes[HandlerTypes["Forbidden"] = 4] = "Forbidden";
  HandlerTypes[HandlerTypes["Conflict"] = 5] = "Conflict";
  HandlerTypes[HandlerTypes["InternalServerError"] = 6] = "InternalServerError";
  HandlerTypes[HandlerTypes["AnyServerError"] = 7] = "AnyServerError";
  HandlerTypes[HandlerTypes["Validation"] = 8] = "Validation";
  HandlerTypes[HandlerTypes["AnyError"] = 9] = "AnyError";
})(HandlerTypes || (exports.HandlerTypes = HandlerTypes = {}));